import { getValueFromCookie, setCookie } from '@/utils/cookie';
import Constants from '@/constants/const';

/**
 * 更新截单时间 Cookie，带有时钟偏移补偿
 * @param expireDtm 服务端返回的截单时间（秒）
 * @param serverDtm 服务端返回的当前服务器时间（秒）
 * @param nowAfter 客户端接收到响应时的本地时间（毫秒）
 * @param config 可选配置（用于 setCookie）
 */
export const updateDeliveryExpireDtm = (expireDtm: number, serverDtm: number, nowAfter: number, config?: any) => {
  if (!expireDtm || !serverDtm) return 0;
  // 计算逻辑：(过期时间 - 服务器当前时间) * 1000 + 客户端当前时间
  // 这样可以抵消服务器与客户端之间的时钟偏移
  const newEndMs = (expireDtm - serverDtm) * 1000 + nowAfter;
  // 只有当计算出的时间在未来时才更新，防止因 stale 数据导致的循环触发
  if (newEndMs > nowAfter) {
    setCookie(Constants.DELIVERY_DATE_EXPIRE_DTM, newEndMs.toString(), null, config);
    return newEndMs;
  }
  return 0;
};

// preorder取默认地址
export const getSelectAddress = (ctx?) => {
  return getValueFromCookie(Constants.SELECT_ADDRESS, ctx);
};

/**
 *
 * @returns 是否是直邮区域
 */
export const isShippingOrder = (ctx?): boolean => {
  const isShippingOrder = getValueFromCookie(Constants.IS_SHIPPING_ORDER, ctx);
  return isShippingOrder === Constants.IS_SHIPPING_ORDER_VAL.IS;
};

/**
 *
 * @returns 是否支持切换日期
 */
export const isSupportChangeDate = (ctx?): boolean => {
  return getValueFromCookie(Constants.IS_SUPPORT_CHANGE_DATE, ctx) === Constants.IS_SHIPPING_ORDER_VAL.IS;
};

/**
 *
 * @param ctx 获取当前的zipcode
 * @returns
 */
export const getZipcode = (ctx?) => {
  return getValueFromCookie(Constants.ZIP_CODE, ctx);
};

/**
 *
 * @param ctx 获取当前的城市
 * @returns
 */
export const getAddressCity = (ctx?) => {
  return getValueFromCookie(Constants.ADDRESS_CITY, ctx);
};

/**
 *
 * @param ctx 获取当前的配送日期
 * @returns
 */
export const getDeliveryDate = (ctx?) => {
  return getValueFromCookie(Constants.DELIVERY_DATE, ctx);
};

/**
 *
 * @param ctx 获取配送的销售组织id
 * @returns
 */
export const getSalesOrgId = (ctx?) => {
  return getValueFromCookie(Constants.SALES_ORG_ID, ctx);
};

export const getIsSupportGlobal = (ctx?) => {
  return `${getValueFromCookie(Constants.IS_SUPPORT_GLOBAL, ctx)}` === '1';
};
